module.exports = __webpack_public_path__ + "img/user-no-image.14b76160.png";